import { render, staticRenderFns } from "./order_afte_sale_detail.vue?vue&type=template&id=54316e32&scoped=true&"
import script from "./order_afte_sale_detail.vue?vue&type=script&lang=js&"
export * from "./order_afte_sale_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_afte_sale_detail.vue?vue&type=style&index=0&id=54316e32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54316e32",
  null
  
)

export default component.exports